import React from "react";
import { FaShieldHalved, FaArrowsRotate, FaGaugeHigh, FaCloud, FaScrewdriverWrench, FaHeadset } from "react-icons/fa6";
import { Container, H2_SIZE, H3_SIZE } from "../home/ui";

const services = [
  {
    icon: FaShieldHalved,
    title: "Security Updates",
    text: "We protect your website from malware, hacking attempts and other threats.",
    tone: "bg-[#DFF7EC] text-[#10B981]",
  },
  {
    icon: FaArrowsRotate,
    title: "Regular Updates",
    text: "Keep your CMS, plugins and themes updated for optimal performance.",
    tone: "bg-[#EEE6FF] text-[#7C3AED]",
  },
  {
    icon: FaGaugeHigh,
    title: "Performance Monitoring",
    text: "We monitor your website speed and fix issues to keep it running smoothly.",
    tone: "bg-[#EEE6FF] text-[#7C3AED]",
  },
  {
    icon: FaCloud,
    title: "Backups & Recovery",
    text: "Regular backups to ensure your data is always safe and can be restored quickly.",
    tone: "bg-[#E3EDFF] text-[#2563EB]",
  },
  {
    icon: FaScrewdriverWrench,
    title: "Bug Fixes",
    text: "We identify and fix errors, bugs and broken functionalities.",
    tone: "bg-[#FFEDD5] text-[#F97316]",
  },
  {
    icon: FaHeadset,
    title: "Dedicated Support",
    text: "Get expert help whenever you need it, via chat, email or call.",
    tone: "bg-[#FFEDD5] text-[#F97316]",
  },
];

const MaintServices = () => (
  <section className="bg-gradient-to-b from-white to-[#F7F9FE] py-[48px] lg:py-[68px]">
    <Container className="max-w-[1200px]">
      <div className="text-center">
        <h2 className={`font-extrabold tracking-tight text-[#0B1A4A] ${H2_SIZE}`}>
          Our Website <span className="text-[#1E6BFF]">Maintenance Services</span>
        </h2>
        <p className="mx-auto mt-[12px] max-w-[620px] text-[15px] leading-[1.6] text-slate-600 sm:text-[16px]">
          Everything you need to keep your website secure, fast and up to date.
        </p>
      </div>

      <div className="m-swipe mt-[36px] grid gap-[20px] sm:grid-cols-2 lg:grid-cols-3">
        {services.map((s) => (
          <div
            key={s.title}
            className="flex flex-col items-center rounded-[18px] bg-white px-[24px] py-[28px] text-center shadow-[0_14px_36px_-24px_rgba(40,60,140,0.35)] transition hover:-translate-y-1"
          >
            <span className={`inline-flex h-[68px] w-[68px] items-center justify-center rounded-[16px] text-[30px] ${s.tone}`}>
              <s.icon />
            </span>
            <h3 className={`mt-[18px] font-bold text-[#0B1A4A] ${H3_SIZE}`}>{s.title}</h3>
            <p className="mt-[8px] max-w-[300px] text-[14px] leading-[1.55] text-slate-600">{s.text}</p>
          </div>
        ))}
      </div>
    </Container>
  </section>
);

export default MaintServices;
